export const WIDTH_OF_FORM_LABEL = '300px'
export const WIDTH_OF_FORM_LABEL_MODAL = '200px'

/** How many rows a list starts with, and the sizes it offers instead. */
export const DEFAULT_PAGE_SIZE = 25
export const PAGE_SIZE_OPTIONS = [25, 50, 100]
